// Componentes de estilos reutilizables usando clases de Tailwind

export const btnPrimary = 'inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg font-medium bg-primary-600 text-white hover:bg-primary-700 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors';

export const btnSecondary = 'inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg font-medium bg-secondary-100 text-secondary-900 hover:bg-secondary-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors dark:bg-secondary-800 dark:text-secondary-100 dark:hover:bg-secondary-700';

export const btnOutline = 'inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg font-medium border-2 border-primary-600 text-primary-600 hover:bg-primary-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors dark:border-primary-400 dark:text-primary-400 dark:hover:bg-primary-950';

export const btnGhost = 'inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg font-medium text-secondary-600 hover:bg-secondary-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors dark:text-secondary-400 dark:hover:bg-secondary-800';

export const btnDanger = 'inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg font-medium bg-danger-500 text-white hover:bg-danger-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-danger-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors';

export const btnSm = 'px-3 py-1.5 text-sm gap-1.5';

export const btnLg = 'px-6 py-3 text-base gap-2';

export const input = 'w-full px-4 py-3 rounded-lg border border-secondary-300 dark:border-secondary-600 bg-white dark:bg-secondary-800 text-secondary-900 dark:text-secondary-100 placeholder-secondary-400 dark:placeholder-secondary-500 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 disabled:opacity-50 disabled:cursor-not-allowed';

export const inputError = 'border-danger-500 focus:ring-danger-500/20 focus:border-danger-500';

export const label = 'block text-sm font-medium text-secondary-700 dark:text-secondary-300 mb-1.5';

export const card = 'bg-white dark:bg-secondary-800 rounded-xl border border-secondary-200 dark:border-secondary-700 shadow-card hover:shadow-card-hover transition-shadow duration-300 overflow-hidden';

export const cardHeader = 'px-6 py-4 border-b border-secondary-200 dark:border-secondary-700';

export const cardBody = 'p-6';

export const cardFooter = 'px-6 py-4 border-t border-secondary-200 dark:border-secondary-700 bg-secondary-50 dark:bg-secondary-900/50';

export const badge = 'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium';

export const badgePrimary = 'bg-primary-100 text-primary-800 dark:bg-primary-900/30 dark:text-primary-300';

export const badgeSuccess = 'bg-success-500/10 text-success-600 dark:bg-success-500/20 dark:text-success-400';

export const badgeWarning = 'bg-warning-500/10 text-warning-600 dark:bg-warning-500/20 dark:text-warning-400';

export const badgeDanger = 'bg-danger-500/10 text-danger-600 dark:bg-danger-500/20 dark:text-danger-400';

export const badgeSecondary = 'bg-secondary-100 text-secondary-600 dark:bg-secondary-700 dark:text-secondary-300';

export const tableContainer = 'overflow-x-auto';

export const table = 'w-full text-sm';

export const tableHead = 'bg-secondary-50 dark:bg-secondary-900/50';

export const tableHeader = 'px-4 py-3 text-left text-xs font-semibold text-secondary-500 dark:text-secondary-400 uppercase tracking-wider';

export const tableBody = 'divide-y divide-secondary-200 dark:divide-secondary-700';

export const tableRow = 'hover:bg-secondary-50 dark:hover:bg-secondary-800/50 transition-colors';

export const tableCell = 'px-4 py-3 text-secondary-900 dark:text-secondary-100';

export const modalOverlay = 'fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4';

export const modalContent = 'bg-white dark:bg-secondary-800 rounded-xl shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto';

export const modalHeader = 'px-6 py-4 border-b border-secondary-200 dark:border-secondary-700 flex items-center justify-between';

export const modalBody = 'p-6';

export const modalFooter = 'px-6 py-4 border-t border-secondary-200 dark:border-secondary-700 bg-secondary-50 dark:bg-secondary-900/50 flex items-center justify-end gap-3';

export const fab = 'fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full bg-primary-600 text-white shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-105 hover:shadow-xl active:scale-95 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2 dark:bg-primary-500';

export const pageContainer = 'min-h-screen bg-secondary-50 dark:bg-secondary-950';

export const pageHeader = 'sticky top-0 z-40 bg-white/80 dark:bg-secondary-950/80 backdrop-blur-md border-b border-secondary-200 dark:border-secondary-800';

export const skeleton = 'animate-pulse bg-secondary-200 dark:bg-secondary-700 rounded';

export const formGroup = 'space-y-1.5';

export const formError = 'text-sm text-danger-600 dark:text-danger-400';

export const formHelp = 'text-sm text-secondary-500 dark:text-secondary-400';